import { useEffect, useState } from 'react'
import { mountNediTheme, NEDI_CONTRACT_VERSION, NEDI_UI_WEB_VERSION } from './mountNediTheme'
import { NediScreen, NediStack, NediInline } from './NediLayout'
import NediEmptyState from './NediEmptyState'
import HistoriasWorkspace from '../atlasVivo/HistoriasWorkspace'
import DiaWorkspace from '../atlasVivo/DiaWorkspace'
import CityReplayPanel from '../atlasVivo/CityReplayPanel'
import WorkspaceStatus from '../atlasVivo/WorkspaceStatus'
import OfflineBadge from '../atlasVivo/OfflineBadge'
import ConfirmDialog from '../../ConfirmDialog'
import '../atlasVivo/tokens.css'
import '../atlasVivo/Buttons.css'
import './nediAnatomy.css'
import './NediWorkspaceAnatomy.css'

const SYNTHETIC_DATE = new Date('2042-04-17T12:00:00')

const DIA_EVENTS = [
  {
    title: 'Café Horizonte — FICTÍCIO',
    start: new Date('2042-04-17T09:30:00'),
    allDay: false,
    resource: { color: '#68a4ff' },
  },
  {
    title: 'Biblioteca Aurora — FICTÍCIA',
    start: new Date('2042-04-17T14:00:00'),
    allDay: false,
    resource: { color: '#2ed3b7' },
  },
]

const HISTORIAS = [
  {
    key: 'insights',
    iconName: 'sparkles',
    title: 'Insights demo 17',
    description: 'Síntese sintética Abr/2042 · Cidade Exemplo (fictícia)',
    onOpen: () => {},
  },
  {
    key: 'memory',
    iconName: 'book',
    title: 'Memory Book fixture',
    description: 'Relatório demo · sem dados pessoais',
    onOpen: () => {},
  },
]

const DADOS = [
  {
    key: 'import',
    iconName: 'database',
    title: 'Importar fontes (demo)',
    description: 'Painel Dados · fixture Abr/2042',
    onOpen: () => {},
  },
  {
    key: 'health',
    iconName: 'heart',
    title: 'Integrações demo',
    description: 'Health check sintético',
    onOpen: () => {},
  },
]

const TABS = [
  { id: 'atlas', label: 'Atlas' },
  { id: 'dia', label: 'Dia' },
  { id: 'historias', label: 'Histórias' },
  { id: 'dados', label: 'Dados' },
  { id: 'offline', label: 'Offline' },
  { id: 'replay', label: 'Replay' },
  { id: 'destructive', label: 'Destructive' },
]

/**
 * Aceite harness for 2.3/2.4 — synthetic Abr/2042 only.
 * Open with ?nediAnatomy=1
 */
export default function NediWorkspaceAnatomy() {
  const [tab, setTab] = useState('historias')
  const [confirmOpen, setConfirmOpen] = useState(true)

  useEffect(() => {
    mountNediTheme({ activateSuiteGlass: true })
  }, [])

  return (
    <div
      className="nedi-workspace-anatomy atlas-vivo-scope"
      data-testid="nedi-workspace-anatomy"
      data-nedi-anatomy-harness="1"
    >
      <NediScreen>
        <NediStack gap="hero">
          <header className="nedi-anatomy-banner" aria-label="Nedi workspace anatomy harness">
            <p className="nedi-anatomy-eyebrow">Nedi anatomy · 2.3 / 2.4 Aceite</p>
            <p>
              nedi-ui-web {NEDI_UI_WEB_VERSION} · contractVersion {NEDI_CONTRACT_VERSION}
            </p>
            <p className="nedi-anatomy-note">
              Fixture sintético Abr/2042 · Café Horizonte — FICTÍCIO · sem PII · sem font download
            </p>
          </header>

          <NediInline className="nedi-anatomy-tabs" aria-label="Seções Aceite">
            {TABS.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`av-btn ${tab === item.id ? 'av-btn--primary' : 'av-btn--ghost'}`}
                aria-pressed={tab === item.id}
                onClick={() => setTab(item.id)}
              >
                {item.label}
              </button>
            ))}
          </NediInline>

          <div className="nedi-anatomy-stage" data-anatomy-tab={tab}>
            {tab === 'atlas' && (
              <section aria-label="Atlas empty chrome" data-nedi-workspace="atlas">
                <NediEmptyState
                  title="Mapa sem pontos (demo)"
                  message="Fixture Abr/2042 vazio · importe fontes ou use TIMELINE_MAP_FIXTURE no iOS."
                  actionLabel="Importar dados"
                  onAction={() => {}}
                />
              </section>
            )}

            {tab === 'dia' && (
              <div className="nedi-anatomy-panel nedi-anatomy-panel--dia">
                <DiaWorkspace
                  selectedDate={SYNTHETIC_DATE}
                  dayEvents={DIA_EVENTS}
                  eventDays={new Set(['2042-04-17'])}
                />
              </div>
            )}

            {tab === 'historias' && (
              <div className="nedi-anatomy-panel nedi-anatomy-panel--historias">
                <HistoriasWorkspace stories={HISTORIAS} />
              </div>
            )}

            {tab === 'dados' && (
              <div className="nedi-anatomy-panel nedi-anatomy-panel--dados">
                <HistoriasWorkspace
                  stories={DADOS}
                  eyebrow="DADOS"
                  title="Dados"
                  subtitle="Manutenção sintética do percurso · Abr/2042"
                  ariaLabel="Workspace Dados"
                />
              </div>
            )}

            {tab === 'offline' && (
              <section aria-label="Offline e erro">
                <WorkspaceStatus
                  offlineCachedAt="2042-04-17T15:40:00.000-03:00"
                  error="Sem conexão (demo). Mostrando últimos dados salvos."
                >
                  <p className="nedi-anatomy-offline-body">
                    Conteúdo cached · OfflineBadge via NediStatusChip
                  </p>
                </WorkspaceStatus>
                <div className="nedi-anatomy-spacer">
                  <OfflineBadge compact />
                </div>
                <WorkspaceStatus
                  error="Falha de rede sintética"
                  onRetry={() => {}}
                />
              </section>
            )}

            {tab === 'replay' && (
              <CityReplayPanel
                selectedCity="Cidade Exemplo (fictícia)"
                onCitySearch={async (q) => {
                  if (q.length < 2) return []
                  return [
                    {
                      city: 'Cidade Exemplo (fictícia)',
                      state: 'XX',
                      country: 'Demo',
                      count: 5,
                    },
                  ]
                }}
                onCitySelect={() => {}}
              />
            )}

            {tab === 'destructive' && (
              <section aria-label="Destructive confirm">
                <p className="nedi-anatomy-note">
                  ConfirmDialog + AvButton destructive · fluxo ImportModal Aceite
                </p>
                <button
                  type="button"
                  className="av-btn av-btn--destructive"
                  onClick={() => setConfirmOpen(true)}
                >
                  Excluir fonte demo
                </button>
                <ConfirmDialog
                  open={confirmOpen}
                  title="Excluir permanentemente?"
                  message="Demo Abr/2042 · nenhum dado real. Confirma exclusão sintética desta fonte?"
                  destructive
                  confirmLabel="Confirmar"
                  cancelLabel="Cancelar"
                  onConfirm={() => setConfirmOpen(false)}
                  onCancel={() => setConfirmOpen(false)}
                />
              </section>
            )}
          </div>
        </NediStack>
      </NediScreen>
    </div>
  )
}
